import { render, staticRenderFns } from "./msg-list-div.vue?vue&type=template&id=991ee16c"
import script from "./msg-list-div.vue?vue&type=script&lang=ts"
export * from "./msg-list-div.vue?vue&type=script&lang=ts"
import style0 from "./msg-list-div.vue?vue&type=style&index=0&id=991ee16c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports